const user = {
  state: {
    token: '',
    info: {},
    editId: '',
    isCopy: false,
    mode: '',
    pageTotal: 1,
    pageSize: 10,
    currentPage: 1
  },
  mutations: {
    // 设置token
    SET_TOKENAndUSER (state, data) {
      state.token = data.token
      state.info = data.info
    },
    // 设置编辑id
    SET_EDITID (state, data) {
      state.editId = data.id
      state.isCopy = data.copy
      state.mode = data.mode
    },
    // 设置页码总数
    SET_PAGETOTAL (state, data) {
      state.pageTotal = data
    },
    // 设置每页数量
    SET_PAGESIZE (state, data) {
      state.pageSize = data
    },
    // 设置当前页
    SET_CURRENTPAGE (state, data) {
      state.currentPage = data
    }
  },
  actions: {
    // 设置token和用户
    SetTokenAndUser ({ commit }, data) {
      commit('SET_TOKENAndUSER', data)
    },
    // 设置编辑ID
    SetEditId ({ commit }, data) {
      commit('SET_EDITID', data || {id: '', copy: false, mode: ''})
    },
    // 设置页码总数
    SetPageTotal ({ commit }, data) {
      commit('SET_PAGETOTAL', data)
    },
    // 设置每页数量
    SetPageSize ({ commit }, data) {
      commit('SET_PAGESIZE', data)
    },
    // 设置当前页
    SetCurrentPage ({ commit }, data) {
      commit('SET_CURRENTPAGE', data)
    },
    // 重置页码
    RestPage ({ commit }) {
      commit('SET_PAGETOTAL', 0)
      commit('SET_CURRENTPAGE', 1)
      commit('SET_PAGETOTAL', 1)
    },
    // 获取用户
    GetUser (context) {
      return context.state.info
    },
    // 获取用户权限列表
    GetPowerList ({ state }) {
      return new Promise((resolve, reject) => {
        const power = state.info.moduleInfoList
        if (power) {
          resolve(power)
        } else {
          reject(power)
        }
      })
    }
  },
  getters: {
    // 判断token是否存在
    isToken (state) {
      let ble = false
      if (state.token !== '') {
        ble = true
      }
      return ble
    },
    // 判断用户是否存在
    isUser (state) {
      let ble = false
      if (Object.keys(state.info).length > 0) {
        ble = true
      }
      return ble
    },
    // 判断编辑ID是否存在
    isEditId (state) {
      let ble = false
      if (state.editId !== '' && state.isCopy) {
        ble = 3
      } else if (state.editId !== '' && !state.isCopy) {
        ble = 2
      } else if (state.editId === '' && !state.isCopy) {
        ble = 1
      }
      return ble
    },
    isViewMode (state) {
      let ble = false
      if (state.mode === 'view') {
        ble = true
      }
      return ble
    },
    isAuditMode (state) {
      let ble = false
      if (state.mode === 'audit') {
        ble = true
      }
      return ble
    },
    // 判断是否为媒体主
    isMediaOwner (state) {
      let ble = false
      if (state.info.isSspUser === 1) {
        ble = true
      }
      return ble
    }
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js